import { render, staticRenderFns } from "./bar_chart.vue?vue&type=template&id=f5a52878&scoped=true"
import script from "./bar_chart.vue?vue&type=script&lang=js"
export * from "./bar_chart.vue?vue&type=script&lang=js"
import style0 from "./bar_chart.vue?vue&type=style&index=0&id=f5a52878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a52878",
  null
  
)

export default component.exports